import React from "react";

import { useFeatureFlagsState } from "hooks/FeatureFlagsContext";
import { SingleJob, SingleCompany } from "interfaces/api/apiInterfaces";
import { JobAlertsModule } from "./JobAlertsModule";

interface JobAlertsModuleProps {
    job: SingleJob;
    company: SingleCompany;
}

const JobAlert = (props: JobAlertsModuleProps): React.ReactElement => {
    const { FEATURE_FLAG_INHOUSE_JOB_ALERTS } = useFeatureFlagsState();
    const { job, company } = props;

    if (!FEATURE_FLAG_INHOUSE_JOB_ALERTS) {
        return null;
    }

    if (job.locations && job.locations.length > 1) {
        return null;
    }

    if (company.state !== "limited") {
        return null;
    }

    const category = {
        value: job.categories?.[0]?.code,
        label: job.categories?.[0]?.value,
    };

    const location = {
        value: job.locations?.[0]?.value,
        label: job.locations?.[0]?.value,
    };

    return (
        <JobAlertsModule
            jobNormalizedTitle={job.normalizedTitle}
            jobLevel={job.levels?.[0]?.value}
            jobLocations={[location]}
            jobCategory={category}
        />
    );
};

export {
    JobAlert
};
